import { render, staticRenderFns } from "./AddressFormItem.vue?vue&type=template&id=4cc56656&scoped=true"
import script from "./AddressFormItem.vue?vue&type=script&lang=js"
export * from "./AddressFormItem.vue?vue&type=script&lang=js"
import style0 from "./AddressFormItem.vue?vue&type=style&index=0&id=4cc56656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc56656",
  null
  
)

export default component.exports